import { ConfirmationBodyExtraParams } from '../../../modal/ConfirmModal/ConfirmModal';
import { useAnalyticsTracker } from '../../../tracking/hooks/useAnalyticsTracker';
import { CheckboxWrapper } from '../../../checkbox/CheckboxWrapper';
import { DisablePipelineTrackers } from '../../tracking/disable-pipeline-trackers';

export function DisablePipelineDialogBody({
  setExtraParams
}: ConfirmationBodyExtraParams<{ cancelRunningJobs: boolean }>) {
  const { eventTrack } = useAnalyticsTracker();

  return (
    <div className='text-left'>
      <span className='text-secondary'>
        Your Pipeline will stop ingesting data. Hevo will restart historical load when you enable
        the Pipeline.
      </span>

      <CheckboxWrapper
        className='mt-5'
        dataId='cancel-running-jobs'
        checkboxProps={{
          onChange: e => {
            eventTrack({
              action: DisablePipelineTrackers.CANCEL_JOB_CLICK
            });

            setExtraParams({
              cancelRunningJobs: e.target.checked
            });
          }
        }}
        label='Cancel Running Jobs?'
      >
        Cancelling a job might lead to inconsistent data in the destination till next job runs.
      </CheckboxWrapper>
    </div>
  );
}
